module.exports = __webpack_public_path__ + "img/main.aee58b6d.png";